module.exports = __webpack_public_path__ + "img/banner-super.a6d9f7b3.png";